import { titleFromPath } from "app/header/parts/HeaderTitle";
import { isEn } from "app/i18n/i18n";
import { Modal, Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { menuSlice } from "redux/slices/menuSlice";
import menuItemsEn from "../config/menuItems_en.json";
import menuItemsJa from "../config/menuItems_ja.json";
import { Title } from "../../../../app/header/tree/Title";
import { MenuLink } from "../../../../app/header/tree/MenuLink";

export const MobileMenu = () => {
  const menuItems = isEn() ? menuItemsEn : menuItemsJa;
  const showMenu = useSelector((state) => state.menu.showMenu);
  const menuBtnPosition = useSelector((state) => state.preferences["grp-menu-side"][0]);
  const isMenuBtnPositionLeft = menuBtnPosition === "Left";
  const setShowMenu = (bool) => dispatch(menuSlice.actions.setShowMenu(bool));
  const dispatch = useDispatch();

  return (
    <Modal
      show={showMenu}
      onHide={() => setShowMenu(false)}
      className={`mobile-menu ${isMenuBtnPositionLeft ? "right-margin" : "left-margin"}`}
    >
      {menuItems.map(linksToLabels).map(renderMobile)}
    </Modal>
  );
};

export const MobileMenuButton = () => {
  const dispatch = useDispatch();
  return <Navbar.Toggle className="border-0" onClick={() => dispatch(menuSlice.actions.setShowMenu(true))} />;
};

export const renderMobile = (item, key) => {
  if (item.link) return <MenuLink key={key} {...item} isMobile={1} />;
  else if (item.title) return <Title key={key} {...item} />;
  return null;
};

const linksToLabels = (item) => {
  item.label = item.label || titleFromPath(item.link || "");
  return item;
};
